import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

export class CommunicationsRequestConferenceParticipantUpdateSchema extends CommunicationsRequestSchema {
  public static readonly conferenceFriendlyName = 'conferenceFriendlyName';

  public static readonly callSid = 'callSid';

  public static readonly hold = 'hold';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[CommunicationsRequestConferenceParticipantUpdateSchema.conferenceFriendlyName] =
      SchemaField.autoGeneratedDocId(undefined).required();
    parameters[CommunicationsRequestConferenceParticipantUpdateSchema.callSid] =
      SchemaField.string(undefined).required();
    parameters[CommunicationsRequestConferenceParticipantUpdateSchema.hold] = SchemaField.boolean(undefined).optional();

    return parameters;
  }
}
